import {
  INITIATED_STATUS,
  ACTIVE_STATUS,
  FINISHED_STATUS,
  CANCELLED_STATUS,
  ALL_STATUS,
} from '../../common/constants/MOs.js'
import {moListQuerySelector, isFilteredSelector} from './moListSelectors.js'
import {useSelector} from '../../store.js'

/**
 * Empty list component for the Manufacturing Orders list page.
 *
 * @param {Object} props - The component props.
 * @param {String} props.colSpan - The number of columns to span.
 *
 * @returns {React.ReactElement} The rendered component.
 */
export default function EmptyList({colSpan}) {
  const status = useSelector(moListQuerySelector).status
  const isFiltered = useSelector(isFilteredSelector)

  return (
    <tr className="table__tr">
      <td className="table__td" colSpan={colSpan}>
        <div className="padding-top-25 padding-bottom-25 align-center">
          <strong className="text--md-grey fs-02 lh-md">
            {isFiltered
              ? 'No MFG Orders match the current search terms.'
              : (status === INITIATED_STATUS &&
                  'There are no initiated MFG Orders. You can create one using the “Initiate a MFG Order” button.') ||
                (status === ACTIVE_STATUS &&
                  'None of your MFG Orders are active.') ||
                (status === FINISHED_STATUS &&
                  'None of your MFG Orders are finished.') ||
                (status === CANCELLED_STATUS &&
                  'None of your MFG Orders are cancelled.') ||
                (status === ALL_STATUS && 'There aren’t any MFG Orders.')}
          </strong>
        </div>
      </td>
    </tr>
  )
}
